import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getAddons({
    name, type, stockType, stockMin, stockMax, placeIds, isActive, page, limit
}) {
    try {
        let packages = await axios.Get({
            url: `${adminUrl}/add-ons/list`,
            params: {
                name: name || '',
                type: type || '',
                stockType: stockType || '',
                stockMax: stockMax || '',
                stockMin: stockMin || '',
                placeIds: placeIds || '',
                isActive: isActive || '',
                page: page,
                limit: limit
            }
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getAddon(itemId) {
    try {
        let packages = await axios.Get({
            url: `${adminUrl}/add-ons/${itemId}`,
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getServices(type, placeId) {
    try {
        let packages = await axios.Get({
            url: `${adminUrl}/add-ons/service?type=${type}&placeId=${placeId || ''}`,
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getAddOnCoach(name) {
    try {
        let coaches = await axios.Get({
            url: `${adminUrl}/add-ons/coach?name=${name}`,
        });

        if (coaches.statusCode !== 200) {
            return { error: coaches.message };
        }

        return { data: coaches.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function createAddon(body) {
    try {
        let packages = await axios.Post({
            url: `${adminUrl}/add-ons/create`,
            data: { ...body }
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updateAddon(body) {
    try {
        let packages = await axios.Post({
            url: `${adminUrl}/add-ons/update`,
            data: body
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updateAddonService(body) {
    try {
        let packages = await axios.Post({
            url: `${adminUrl}/add-ons/service`,
            data: body
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getHistory(id) {
    try {
        let packages = await axios.Get({
            url: `${adminUrl}/add-on/stock/balance?productId=${id}`,
        });
        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }
        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getAddOnHistory(id) {
    try {
        let response = await axios.Get({
            url: `${adminUrl}/add-ons/history/${id}`
        })
        if (response.statusCode !== 200) {
            return { error: response.message }
        }
        return { data: response.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function getBalance(id) {
    try {
        let response = await axios.Get({ url: `${adminUrl}/add-on/stock/balance?productId=${id}` })
        console.log('here response', response)
        if (response.statusCode !== 200) {
            return { error: response.data?.message }
        }
        return { data: response.data }
    } catch (e) {
        return { error: e.response?.data || e.message }
    }
}

export async function addBalance(payload) {
    try {
        let response = await axios.Post({ url: `${adminUrl}/add-on/stock/add`, data: payload })
        if (response.statusCode !== 200) {
            return { error: response.data?.message }
        }
        return { data: response.data }
    } catch (e) {
        return { error: e.response?.data || e.message }
    }
}